module.exports = "/_next/static/images/bank-mandiri-icon-434f0e111863d82c82e68d329c8f1060.svg";